import { render, staticRenderFns } from "./SubmitButton.vue?vue&type=template&id=618a411f&scoped=true"
import script from "./SubmitButton.vue?vue&type=script&lang=ts"
export * from "./SubmitButton.vue?vue&type=script&lang=ts"
import style0 from "./SubmitButton.vue?vue&type=style&index=0&id=618a411f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "618a411f",
  null
  
)

export default component.exports